import { useLocation, useSearchParams } from "react-router-dom";

export function useQueryGates() {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  // Root states
  const isCartPage =
    pathname.includes("/winkelwagen") || pathname.includes("/webshop/checkout");
  const isDoorConfigurator = !!searchParams.get("door");
  const isStandardProductPage = !!searchParams.get("standard-product");

  // Derived gates
  const enableDeliveryCostsQuery = !isDoorConfigurator && !isCartPage;

  // Warranty is a checkout concern — disable on configurator-only pages
  const enableWarrantyOrPayment = !isDoorConfigurator && !isStandardProductPage;

  return {
    enableDeliveryCostsQuery,
    enableWarrantyOrPayment,

    // Export raw states in case consumers need them
    isCartPage,
    isDoorConfigurator,
    isStandardProductPage,
  };
}
